export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    tableGroupList: [
      {
        tableGroupIdx: 1,
        name: "1층",
      },
      {
        tableGroupIdx: 2,
        name: "2층",
      },
    ],
  },
};
